import * as React from "react";
import { useTranslation } from "react-i18next";
import ProfileCompanyDetails from "../../presentations/ProfileCompanyDetails";

const ProfileCompanyDetailsContainer = () => {

  const { t } = useTranslation();
  
  const data = {
    company: "Praxical Technologies pvt. ltd",
    role: "Marketing Manager",
  };

  return (
    <div>
      <div className="mb-2 font-semibold text-gray-700">
        {t("profileSummary.label.companyDetails")}
      </div>
      <div>
        <ProfileCompanyDetails companyDetails={data}></ProfileCompanyDetails>
      </div>
    </div>
  );
};

export default ProfileCompanyDetailsContainer;
